var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"youjiaopage_wrap"},[_c('navBar'),_c('banner2',{attrs:{"banner-h":_vm.h1,"banner-p":_vm.p1,"banner-img":_vm.Img1}}),_c('div',{staticClass:"Crumbs"},[_c('div',[_vm._v("当前位置：首页> "),_c('router-link',{attrs:{"to":"/news"}},[_c('span',[_vm._v("新闻中心")])])],1)]),_c('router-view'),_c('footer2')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }